import React, { useState, useEffect } from 'react';
import { Image, FormGroup, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import validate from 'validate.js';
import { isEmpty } from 'lodash';
import { sendPasswordResetCode, resetUserPassword, resendVerificationCode, resetSessionState, hideError, hideFeildValidationError } from 'actions';



const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true
  }
};

const EmailForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const session = useSelector(state => state.session);

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      email: ''
    },
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState(formState => ({
      ...formState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  useEffect(() => {
    if (session.error_type === 'validation') {
      const errors = session.error;
      setFormState(formState => ({
        ...formState,
        isValid: errors ? false : true,
        errors: errors || {}
      }));
    }
  }, [session.error_type, session.error]);

  useEffect(() => {
    const redirect_url = new URLSearchParams(window.location.search).get('redirect_url');
    if (session.loggedIn && !isEmpty(localStorage.getItem("token")) && !isEmpty(session.user)) {
      //router.history.push('/');

      if (isEmpty(redirect_url)) {
        setTimeout(function () {
          window.location.replace("/");
        }, 500);
      }
      else { 
        let url = redirect_url + '?token=' + localStorage.getItem("token");
        setTimeout(function () {
          window.location.replace(url);
        }, 500);
      }
    }
  }, [session.loggedIn, session.user, localStorage.getItem("token")]);

  const hasError = field => formState.touched[field] && formState.errors[field] ? true : false;

  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
    dispatch(hideFeildValidationError(event.target.name));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    await dispatch(sendPasswordResetCode(formState.values, navigate)); // Pass navigate to action
  };

  return (
    <>
      <div className="premier-logo text-center">
        <Image src="/assets/images/NX-logo.svg" />
      </div>
      <div className="login-form">
        <div className="text-center mb-4">
          <h1 className="font-24 fon-weight-s-bold mb-3">Reset your Password</h1>
          <p className='font-14 font-weight-normal text-secondary'>Please enter your email address. You will receive instructions to reset your password in your inbox.</p>
        </div>
        <Form className='pt-5' onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="font-16 font-weight-medium">
              Email <span className="form-star-span">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              onChange={handleChange}
              value={formState.values.email || ''}
              placeholder="example@gmail.com"
              className={`h-48 border-radius-99 ps-4 font-13 font-weight-normal ${hasError('email') ? 'is-invalid' : ''}`}
            />
            <Form.Control.Feedback type="invalid">
              {hasError('email') ? formState.errors.email[0] : null}
            </Form.Control.Feedback>
          </Form.Group>
          <Button className="w-100 continue-btn h-48 border-radius-99 mb-3 border-0 continue-btn" type="submit">
            Continue
          </Button>
        </Form>
        <div className="pt-4 pb-5">
          {/* <Link to='/verification'> */}

          {/* </Link> */}
          <Link to='/login'>
            <Button className="w-100 h-48 border-radius-99 mb-3 bg-transparent font-weight-s-bold resend-btn">
              Back to login
            </Button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default EmailForm
